// extracted by mini-css-extract-plugin
module.exports = {"container":"BigFiveDomain_container__3Y6uq","text":"BigFiveDomain_text__2-bc5","title":"BigFiveDomain_title__2osT_","description":"BigFiveDomain_description__5hyE0"};